import { Component, OnInit } from "@angular/core";
import { TypeEventOperationHistory } from "@edp-enums/type-event-operation.enum";
import { ConfirmationContactResponse, PaymentAgreement } from "@edp-models/edp-payment-agreement.model";
import { EdpUser } from "@edp-models/user.model";
import { NewModalService } from "@edp-pages/requests-and-operations/services/new-modal.service";
import { EdpPaymentAgreementService } from "@edp-services/edp-payment-agreement.service";
import { EdpSteperService } from "@edp-services/edp-steper.service";
import { PaymentService } from "@edp-services/payment.service";
import { getUser } from "@edp-store/selectors/user.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { isNumber } from "@edp-utils/isNumber.util";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "acceptance-agreement",
    templateUrl: "./acceptance-agreement.component.html",
    styleUrls: ["./acceptance-agreement.component.scss"],
})
export class AcceptanceAgreementComponent implements OnInit {
    public contact: ConfirmationContactResponse;
    public isNumber: boolean;
    public paymentAgreementTerm: PaymentAgreement;
    public user: EdpUser;

    constructor(
        private steperService: EdpSteperService,
        private edpPaymentAgreementService: EdpPaymentAgreementService,
        private readonly modalService: NewModalService,
        private readonly translateService: TranslateService,
        private paymentService: PaymentService,
        private readonly store: Store<IAppState>,
    ) {
        this.store.select(getUser).subscribe(user => {
            this.user = user
        });

        this.paymentAgreementTerm = this.edpPaymentAgreementService.getPaymentAgreementTerm();
        this.contact = this.edpPaymentAgreementService.getConfirmationContactResponse();
        this.isNumber = isNumber(this.contact.contact);
    }

    ngOnInit(): void {
        this.steperService.setActiveStep(4);
        this.setOperationHistory(
            this.paymentAgreementTerm.data?.accountNumber,
            this.contact.contact,
            TypeEventOperationHistory.VIEWSTEP4CONFIRMATION
        );
    }

    goBack() {
        if (this.user) {
            this.goToRequestAndOperations();
        } else {
            this.goToExternalUrl();
        }
    }

    public goToRequestAndOperations() {
        this.modalService.closeModal();
    }

    public goToExternalUrl() {
        const url = this.translateService.instant("pt.edp.edponline.payment.agreement.url.edp");
        window.location.href = url;
    }

    private setOperationHistory(accountNumber: number, contact: string, operation: string) {
        const account = accountNumber.toString();
        this.paymentService.agreementHistory({ account, contact, operation }).subscribe(() => {});
    }
}
